import { render } from "./client-model.vue?vue&type=template&id=f97f83cc"
import script from "./client-model.vue?vue&type=script&lang=js"
export * from "./client-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__